module.exports = __webpack_public_path__ + "static/img/401.f924a799.png";